import { ITranslation } from "./types";

export const el: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Μόλις φύγατε από το κατάστημα; Η απόδειξή σας επεξεργάζεται, ελέγξτε ξανά σε λίγο.<br/>In case of any issues, please reach out through venue support.',
    errorReachOutSupportMsg:
      'In case of any issues, please reach out through venue support.',
  },
  api: {
    E_FORCED_LOGOUT: "Έχετε αποσυνδεθεί, η σύνδεσή σας έληξε.",
  },
  orderStatus: {
    draft: "Πρόχειρη (παραγγελία)",
    contested: "Παραγγελία σε αμφισβήτηση",
    paid: "Πληρωμένη (παραγγελία)",
    unpaid: "Ανεξόφλητη (παραγγελία)",
    pending: "Παραγγελία σε εκκρεμότητα",
    reviewed: "Ελεγμένη (παραγγελία)",
    paymentProcessing: "Παραγγελία σε διαδικασία πληρωμής",
    refunded: "Επιστροφή χρημάτων (παραγγελία)",
    unknown: "Άγνωστο (παραγγελία)",
  },
  receiptsList: {
    headings: {
      date: "Ημερομηνία",
      time: "Ώρα",
      status: "Κατάσταση",
      total: "Σύνολο",
    },
    action: {
      view: "Προβολή",
    },
    statusTooltip: {
      draft: "Πρόχειρο - Η παραγγελία επεξεργάζεται από το σύστημα",
      paid: "Πληρώθηκε - Η παραγγελία επεξεργάστηκε και πληρώθηκε",
      paymentProcessing:
        "Επεξεργασία πληρωμής - Η παραγγελία επεξεργάστηκε και η πληρωμή βρίσκεται σε διαδικασία",
      unpaid:
        "Δεν πληρώθηκε - Η παραγγελία επεξεργάστηκε αλλά η πληρωμή απέτυχε",
      pending:
        "Σε εκκρεμότητα - Η παραγγελία έχει αμφισβητηθεί από τον αγοραστή και αναμένεται επανεξέταση από τον έμπορο",
      reviewed:
        "Επανεξετάστηκε - Η παραγγελία έχει αμφισβητηθεί από τον αγοραστή και ο έμπορος έχει υποβάλει την αναθεώρηση",
    },
    loadMore: "Φόρτωση περισσότερων",
    loadingMore: "Φόρτωση...",
    showing: "Εμφάνιση",
  },
  receiptDetailScreen: {
    headerTitle: "Λεπτομέρειες απόδειξης",
    subtotal: "Μερικό σύνολο",
    taxBreakdown: {
      headers: {
        rate: "Ποσοστό Φ.Π.Α.",
        netto: "Καθαρή αξία",
        brutto: "Τελική αξία",
        tax: "Φ.Π.Α.",
        total: "Σύνολ",
      },
    },
    tax: "Φ.Π.Α.",
    taxCRV: "CRV",
    total: "Σύνολο",
    processTime: "Χρόνος επεξεργασίας",
    date: "Ημερομηνία",
    paymentStatus: "Κατάσταση πληρωμής",
    orderId: "Αριθμός παραγγελίας",
    listOfProducts: "Προϊόντα",
  },
  receiptDetailComplain: {
    reportProblem: "Αναφορά προβλήματος για αυτή την απόδειξη",
    submitReview: "Αποστολή για έλεγχο",
    confirmTitle: "Η απόδειξη εστάλη",
    confirmButton: "Ολοκληρώθηκε",
    addMissingItem: "Προσθήκη ελλείποντος είδους",
    addMissingItemMessage: "Προσθήκη μηνύματος (προαιρετικό)",
    form: {
      email: {
        label: 'Πώς μπορούμε να επικοινωνήσουμε μαζί σας;',
        placeholder: 'Το email σας, π.χ. me@example.com',
        errors: {
          required: 'Απαιτείται διεύθυνση email',
          isEmail: 'Μη έγκυρη διεύθυνση email',
          inUse: 'Η διεύθυνση email χρησιμοποιείται ήδη',
        },
      },
    },
  },
  receiptsScreen: {
    label: {
      contested: "Έλεγχος συναλλαγής",
      draft: "Σε εξέλιξη",
      empty: "ΚΕΝΟ",
      paid: "Πληρωμένη",
      pending: "Σε εξέλιξη",
      refunded: "Επιστροφή Χρημάτων",
      reviewed: "Ολοκληρωμένη επανεξέταση",
      unknown: "Άγνωστο",
      unpaid: "Ανεξόφλητη",
      paymentProcessing: "Επεξεργασία πληρωμής",
    },
    message: {
      contested: "Μήνυμα υπό έρευνα",
      draft: "Μήνυμα προσχέδιο",
      empty: "Κενό μήνυμα",
      paid: "Μήνυμα πληρωμένου",
      pending: "Μήνυμα προσχεδίου",
      refunded: "Μήνυμα επιστραφέντος",
      reviewed: "Μήνυμα επανεξέτασης",
      unpaid: "Μήνυμα μη πληρωμένου",
      paymentProcessing: "Μήνυμα επεξεργασίας πληρωμής",
    },
    minutes: "λεπτά",
    hours: "ώρες",
    days: "ημέρες",
  },
  slideModal: {
    close: "Κλείσιμο",
    searchPlaceholder: "Αναζήτηση είδους",
  },
  receiptsHome: {
    receiptPortal: "Πύλη Αποδείξεων",
    selectPaymentType:
      "Επιλέξτε τη μέθοδο πληρωμής που χρησιμοποιήσατε για να μπείτε στο κατάστημα",
    selectPaymentTypeSubtitle: "Αν χρησιμοποιήσατε το τηλέφωνο ή το smartwatch σας, επιλέξτε Apple Pay ή Google Pay",
    cardBin:
      "Τα πρώτα %{cardBinDigitsCount} ψηφία του αριθμού κάρτας (BIN/IIN)",
    last4: "Τελευταία τέσσερα ψηφία της μεθόδου πληρωμής σας",
    last4Apple: "Τελευταία τέσσερα ψηφία του αριθμού Apple Pay",
    last4Google: "Τελευταία τέσσερα ψηφία του αριθμού Google Pay",
    instructionApple:
      "Εντοπίστε τα τελευταία τέσσερα ψηφία του αριθμού κάρτας Apple Pay στο Apple Wallet σας και εισάγετέ τα παρακάτω",
    openWallet: "Άνοιγμα Wallet",
    instructionGoogle:
      "Εντοπίστε τα τελευταία τέσσερα ψηφία του αριθμού κάρτας Google Pay στο Wallet σας και εισάγετέ τα παρακάτω",
    instructionExternalId:
      "Βρείτε τον αριθμό αναφοράς πληρωμής στην εφαρμογή πληρωμών ή στην τραπεζική σας κίνηση.",
    externalIdLabel: "Αριθμός αναφοράς πληρωμής",
    externalIdPlaceholder: "",
    expDate: "Ημερομηνία λήξης",
    visitDate: "Ημερομηνία επίσκεψής σας",
    submit: "Ανάκτηση απόδειξης/αποδείξεων",
    registerEmail:
      "Εισαγάγετε το email σας για εγγραφή σε μελλοντικές αποδείξεις",
    registerEmailSuccess:
      "Η διεύθυνση email ενημερώθηκε με επιτυχία.",
    registerEmailFail:
      "Η διεύθυνση email δεν ενημερώθηκε επειδή δεν βρέθηκαν αποδείξεις που να συνδέονται με τις παρεχόμενες πληροφορίες κάρτας και/ή ημερομηνίας επίσκεψης.",
    unrecognizedError: "Παρουσιάστηκε μη αναγνωρισμένο σφάλμα",
    inconclusiveCardInfo: "Δεν μπορούμε να βρούμε την απόδειξή σας",
    optionalFieldPlaceholder: 'Προαιρετικό',
    invalidCaptcha: "Μη έγκυρο captcha, προσπαθήστε ξανά",
    oasisApiError:
      "Δεν μπορέσαμε να συνδεθούμε με τον διακομιστή αποδείξεων. Παρακαλούμε δοκιμάστε ξανά αργότερα.",
    orderNotFound: "Η παραγγελία δεν βρέθηκε",
    vatNumberLabel: "ΑΦΜ",
    vatNumberOptional: "(προαιρετικό)",
    vatNumberHelp:
      "Αν θέλετε να προσθέσετε ΑΦΜ σε μελλοντικά τιμολόγια, προσθέστε τον εδώ.",
    vatNumberError: "Εισαγάγετε έναν έγκυρο πορτογαλικό ΑΦΜ (NIF).",
  },
  receiptError: {
    notFound: {
      title: "Η απόδειξη δεν βρέθηκε",
      message: "Δεν μπορέσαμε να βρούμε απόδειξη για αυτήν την παραγγελία. Μπορεί να έχει λήξει, να έχει αφαιρεθεί ή ο σύνδεσμος μπορεί να είναι λανθασμένος.",
      retry: "Δοκιμάστε ξανά",
      contactSupport: "Επικοινωνήστε με την υποστήριξη",
      goBack: "Πίσω",
    },
    serverError: {
      title: "Κάτι πήγε στραβά",
      message: "Αυτό είναι δικό μας πρόβλημα. Παρακαλώ δοκιμάστε ξανά σε λίγο. Αν συνεχίζει, επικοινωνήστε με την ομάδα υποστήριξής μας.",
      retry: "Δοκιμάστε ξανά",
      contactSupport: "Επικοινωνήστε με την υποστήριξη",
    },
  },
  notFound: {
    title: "Η σελίδα δεν βρέθηκε",
    message: "Κάτι πήγε στραβά ή ο σύνδεσμος μπορεί να είναι λανθασμένος.",
    goHome: "Επιστροφή στην αρχική",
    goBack: "Πίσω",
  },
};
